import { OrganizationNiche, OrganizationVaProfile } from "schemas/dashboard";

export type StepType = {
  label: string;
  description: string;
  niche?: OrganizationNiche;
};

export enum TemplateScreen {
  method = "method",
  bento_ai = "bento_ai",
  from_scratch = "from_scratch",
}

export type SaveOrgVaProfileFunc = (
  organizationVaProfile: OrganizationVaProfile,
  excludeIncludeFilterHasChanged?: boolean,
  moveNext?: boolean,
  updateNiche?: boolean,
) => void;
